<template>
    <div class="shared-files-wrapper p-3">
        <i class="fas fa-times dialog-close float-end mb-3" @click="dialogReference.close()"></i>
        <div class="d-flex p-2">
            <span class="me-3">
                <h4>{{ options.title }}</h4>
            </span>
            <span class="mt-2" v-if="sharedFilesUsers?.length > 1">
                <span class="me-2">Shared By</span>
                <select v-model="uploaderId" name="selectSharedBy" class="border-0">
                    <option value="">All</option>
                    <option v-for="user in sharedFilesUsers" :value="user.userId" :key="user.userId">
                        {{ user.firstName }} {{ user.lastName }}
                    </option>
                </select>
            </span>
        </div>
        <div class="mb-3 table-wrapper">
            <table class="table table-borderless">
                <thead>
                    <tr class="bg-table-header">
                        <th v-if="assets?.length">
                            <SortableTh :sort-by="sortBy" :sort-order="sortOrder" sort-string="mimeType">
                                Type
                            </SortableTh>
                        </th>
                        <th v-else>Type</th>
                        <th v-if="assets?.length">
                            <SortableTh :sort-by="sortBy" :sort-order="sortOrder" sort-string="fileName">
                                Name
                            </SortableTh>
                        </th>
                        <th v-else>Name</th>
                        <th v-if="assets?.length">
                            <SortableTh :sort-by="sortBy" :sort-order="sortOrder" sort-string="modifiedDate">
                                Uploaded
                            </SortableTh>
                        </th>
                        <th v-else>Uploaded</th>
                        <th class="d-none d-md-table-cell" v-if="assets?.length">
                            <SortableTh :sort-by="sortBy" :sort-order="sortOrder" sort-string="uploaderLastName">
                                Uploaded By
                            </SortableTh>
                        </th>
                        <th class="d-none d-md-table-cell" v-else>Uploaded By</th>
                    </tr>
                </thead>
                <tbody>
                    <tr class="table-empty" v-if="!isLoading && assets?.length === 0">
                        <td :colspan="columns">
                            <h3>No Shared Files to Display</h3>
                        </td>
                    </tr>
                    <template v-if="isLoading">
                        <tr v-for="i in loadingCount" :key="i" class="table-loading">
                            <td v-for="j in columns" :key="j">
                                <span class="shimmer-loading"></span>
                            </td>
                        </tr>
                    </template>
                </tbody>
                <template v-if="!isLoading">
                    <tbody v-for="asset in assets" :key="asset.id">
                        <ConversationSharedFileRow :asset="asset" :columns="columns"></ConversationSharedFileRow>
                    </tbody>
                </template>
            </table>
        </div>
    </div>
</template>

<style src="./ConversationSharedFiles.scss"></style>
<script lang="ts" src="./ConversationSharedFiles.ts"></script>
